export default "__VITE_ASSET__Dknw3IIg__"